import {ngAsync} from 'shared/utils/ng-@decorators';
import {responseToData, transferify, unRestangularize} from 'shared/utils/data-service-utils';
import type {
    ActionResponse,
    ConfirmableRequest,
    FinishedSaveResponse,
    IdentifiedFile,
    ViewableFile
} from 'typings/portaro.be.types';
import type {IHttpService} from 'angular';

export interface FileQueryParams {
    directory: number;
    excludedFileId?: number
}

export interface FileCreationParams {
    directory?: number;
    name: string
}

export class FileDataService {
    public static serviceName = 'fileDataService';
    public static readonly ROUTE = 'files';

    /*@ngInject*/
    constructor(private $http: IHttpService,
                private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async getFile(id: number): Promise<ViewableFile> {
        try {
            return await this.Restangular
                .one(FileDataService.ROUTE, id)
                .get<ViewableFile>();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async queryByDirectory(params: FileQueryParams): Promise<ViewableFile[]> {
        try {
            return await this.Restangular
                .all(FileDataService.ROUTE)
                .getList<ViewableFile>(params);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async createFile(directoryId?: number, name?: string): Promise<FinishedSaveResponse<ViewableFile>> {
        try {
            return await this.Restangular
                .all(FileDataService.ROUTE)
                .all('create')
                .post({directory: directoryId, name});
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async removeFile(file: IdentifiedFile): Promise<void> {
        try {
            return await this.Restangular
                .one(FileDataService.ROUTE, file.id)
                .remove();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async editFileMetadata(request: IdentifiedFile & ConfirmableRequest): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .all(FileDataService.ROUTE)
                .post(transferify(request));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async modifyFileContent(file: IdentifiedFile, content: string): Promise<IdentifiedFile> {
        try {
            const req = {
                method: 'POST',
                url: `/api/${FileDataService.ROUTE}/${file.id}/modify`,
                headers: {
                    'Content-Type': 'text/plain'
                },
                data: content
            };
            const httpResponse = await this.$http<IdentifiedFile>(req);
            return responseToData(httpResponse);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }
}